import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { mobile_xl } from '../../global/mediaQueryMixin';
import { FlexBetween, HideScrollbar } from '../../global/commonStyle';

interface Props {
  isInbox?: boolean;
  isMessageBox?: boolean;
  isTaskDetailPreviewOpen?: boolean;
  isProjectDetailMessages?: boolean;
  Inbox?: boolean;
  isPosition?: boolean;
  isPadding?: boolean;
  isNewDocPage?: boolean;
  isOverflowHidden?: boolean;
  disabled?: boolean;
}

const MainSection = styled.div<Props>`
  display: flex;
  height: 100vh;
  .mobileView {
    display: none;
  }
  ${(props: Props) =>
    props.isTaskDetailPreviewOpen &&
    css`
      filter: blur(50px);
    `}
  ${mobile_xl(css<Props>`
    flex-direction: column;
    ${(props: Props) =>
      props.isMessageBox &&
      css`
        height: 100dvh;
      `}
    .webview {
      display: none;
    }
    .mobileView {
      display: block;
      position: sticky;
      top: 0px;
      z-index: var(--z-index-99);
      width: 100%;
    }
  `)}
`;

const Content = styled.div<Props>`
  background: var(--background-secondary);
  width: 100%;
  border-left: 0.5px solid var(--border-primary);
  ${HideScrollbar};
  ${(props: Props) =>
    props.isPosition &&
    css`
      position: relative;
    `}
  ${(props: Props) =>
    props.isOverflowHidden &&
    css`
      overflow: hidden;
    `}
  ${mobile_xl(css<Props>`
    margin: var(--space-0);
    width: auto;
    border-left: 0;
    z-index: var(--z-index-0);
    height: 100dvh;
  `)}
`;

const CMDKOverLayDiv = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: var(--background-overlay);
  backdrop-filter: blur(1px);
  z-index: 99999;
`;

const ModalHead = styled.div`
  ${FlexBetween}
  padding: var(--space-12) var(--space-16);
  border-bottom: 0.5px solid var(--border-primary);
`;

const Headline = styled.h6`
  ${Typography.body_lg_semibold}
  color: var(--text-primary);
  margin: var(--space-0);
`;

const SideBarListMain = styled.div<Props>`
  ${(props) =>
    props.disabled &&
    css`
      pointer-events: none;
    `}
`;

export { MainSection, Content, CMDKOverLayDiv, Headline, ModalHead, SideBarListMain };
